export const HOME_PAGE = '/';
export const HOME_FULLNAME_PAGE = 'home';
export const CONTACTS_PAGE = '/contacts';
export const PHONES_PAGE = '/phones';
export const TABLETS_PAGE = '/tablets';
export const ACCESSORIES_PAGE = '/accessories';
export const RIGHTS_PAGE = 'https://github.com/fe-jan23-team-six';
export const GIT_PAGE = 'https://github.com/fe-jan23-team-six/product-catalog';
